import React, { useState, useCallback, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Stack,
  Chip,
  Grid,
  useMediaQuery,
  useTheme,
  Dialog,
} from "@mui/material";
import { ArrowBack, Group, Add } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

import ClientCard from "../components/ClientCard";
import CreateClient from "../components/CreateClient";
import EditClient from "../components/EditClient";
import { getClients } from "../services/source";
import auth from "../services/auth";

const ClientTableScreen = () => {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  // const [hidden, setHidden] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const user = auth.getCurrentUser();
  const userId = user?.data?.companyId || user?.data?.id;

  const getClientsData = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getClients(userId);
      setClients(data);
    } catch (err) {
      console.error("Error fetching clients:", err);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    if (userId) {
      getClientsData();
    }
  }, [userId, getClientsData]);

  const handleEditClient = (client) => {
    setSelectedClient(client);
    setEditDialogOpen(true);
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{ p: { xs: 2, md: 4 }, background: "#f7f5fb", minHeight: "100vh" }}
    >
      <Card
        elevation={0}
        sx={{
          borderRadius: 4,
          mb: 3,
          background: "linear-gradient(90deg, #5b2c72 0%, #7b1fa2 100%)",
          color: "white",
        }}
      >
        <CardContent>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            alignItems={{ xs: "flex-start", sm: "center" }}
            justifyContent="space-between"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Group />
              <Typography variant="h5" fontWeight="bold">
                Clientes
              </Typography>
            </Stack>
            <Box>
              <Chip
                label="Adicionar Cliente"
                color="secondary"
                icon={<Add fontSize="small" />}
                onClick={() => setDialogOpen(true)}
              />
              <Chip
                sx={{ ml: 1 }}
                label="Voltar"
                color="secondary"
                icon={<ArrowBack fontSize="small" />}
                onClick={() => navigate("/dashboard")}
              />
            </Box>
          </Stack>
        </CardContent>
      </Card>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
          <CircularProgress color="secondary" />
        </Box>
      ) : (
        <Grid container spacing={3}>
          {clients.map((client) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={client.id}>
              <ClientCard client={client} onEdit={handleEditClient} />
            </Grid>
          ))}
        </Grid>
      )}

      {/* <Grid container spacing={3}>
        {clients.map((client) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3} // 4 cards per line
            key={client.id}
          >
            <ClientCard client={client} onEdit={handleEditClient} />
          </Grid>
        ))}
      </Grid> */}

      {/* Modal Create Client */}
      <Dialog
        open={dialogOpen}
        fullScreen={fullScreen}
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflowY: "auto",
            maxHeight: "100vh",
            m: fullScreen ? 0 : 2,
            borderRadius: fullScreen ? 0 : 3,
          },
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "100vh",
          }}
        >
          <CreateClient
            onClose={() => setDialogOpen(false)}
            onCreateSuccess={() => {
              setDialogOpen(false);
              getClientsData();
            }}
          />
        </Box>
      </Dialog>

      <Dialog
        open={editDialogOpen}
        fullScreen={fullScreen}
        fullWidth
        maxWidth="md"
        scroll="paper"
        onClose={() => {
          setEditDialogOpen(false);
          setSelectedClient(null);
        }}
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflowY: "auto",
            maxHeight: "100vh",
            m: fullScreen ? 0 : 2,
            borderRadius: fullScreen ? 0 : 3,
          },
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "100vh",
          }}
        >
          <EditClient
            client={selectedClient}
            onClose={() => {
              setEditDialogOpen(false);
              setSelectedClient(null);
            }}
            onDeleteSuccess={() => {
              setEditDialogOpen(false);
              setSelectedClient(null);
              getClientsData();
            }}
            onUpdateSuccess={() => {
              setEditDialogOpen(false);
              setSelectedClient(null);
              getClientsData();
            }}
          />
        </Box>
      </Dialog>
      {/* ######################## */}
    </Box>
  );
};

export default ClientTableScreen;
